"use strict";
exports.__esModule = true;
var ActionTypes;
(function (ActionTypes) {
    ActionTypes["REQUEST"] = "REQUEST";
    ActionTypes["ERROR"] = "ERROR";
    ActionTypes["SUCCESS"] = "SUCCESS";
    ActionTypes["CANCEL"] = "CANCEL";
})(ActionTypes || (ActionTypes = {}));
exports["default"] = ActionTypes;
